import { FormControl, ValidatorFn } from '@angular/forms';
import { ApiValidationService } from './api-validation.service';

export function ApiValidator(apiValidation: ApiValidationService, apiFieldName: string): ValidatorFn {
  let registered: boolean = false;

  return function (control: FormControl): { [key: string]: any } {
      if (!registered) {
        apiValidation.registerField(apiFieldName, control);

        registered = true;
      }

      if (apiValidation.hasFieldError(apiFieldName)) {
        return { apiValidation: apiValidation.getFieldError(apiFieldName) };
      }

      return null;
    };
}



// WEBPACK FOOTER //
// /dist/src/app/shared/api-validation/api-validator.function.ts